import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { getMenuCache, getSelectedMenu } from "../../store/sagas/selectors";
import { PatternSelector } from "../PatternSelector/PatternSelector";
import { VisibleItemsCounter } from "./VisibleItemsCounter";

const FilterFooterContainer = styled.div`
    position: relative;
    display: flex;
    height: 30px;
    width: 100%;
    font-size: 13px;
    align-items: center;
    border-bottom: solid thin #ccc;
    padding-bottom: 5px;
    ${({ theme }) =>
        theme.bp.xxxl`
            font-size: 1em;
        `}

    ${({ theme }) =>
        theme.bp.tb`
        justify-content: space-between;
        `}
`;

export const FilterFooter = ({
    hideNumVisibleItems,
    numVisibleItems,
}: {
    hideNumVisibleItems: boolean;
    numVisibleItems: number;
}) => {
    const menus = useSelector(getMenuCache);
    const selectedMenu = useSelector(getSelectedMenu);
    const patterns = menus[selectedMenu]?.availablePatterns;

    return (
        <FilterFooterContainer>
            {!hideNumVisibleItems ? <VisibleItemsCounter numVisibleItems={numVisibleItems} /> : null}
            {patterns?.length > 0 ? <PatternSelector /> : null}
        </FilterFooterContainer>
    );
};
